// src/Api/services/clientService.ts

import { GetRequestsRenseponse } from "../../Types/ServiceManagement";
import api from "../axios";

import { ENDPOINTS } from "../endpoints";

export const requestService = {
  

  updateServiceRequestStatus: (status: string, id: string, reason?: string) =>
    api.put(`${ENDPOINTS.SERVICE_REQUESTS}/${id}`, {
      status: status,
      reason: reason,
    }),
};
